import React from "react";
import MainSummaryContainer from "./MainSummary.css";

const MainSummary = () => {
  return (
    <MainSummaryContainer>
      <div className="summary">
        <div className="summarycard">
          <div className="header">
            <h6>창조경영활동</h6>
            <button>MORE</button>
          </div>
          <div>
            <ul></ul>
          </div>
        </div>
        <div className="summarycard">
          <div className="header">
            <h6>공지사항</h6>
            <button>MORE</button>
          </div>
          <div>
            <ul></ul>
          </div>
        </div>
        <div className="summarycard">
          <div className="img"></div>
          <div className="img"></div>
        </div>
      </div>
    </MainSummaryContainer>
  );
};

export default MainSummary;
